import React, { Component } from "react";
import { Form, Button } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroCompliance from "./HeaderIntroCompliance";
import TrademarkRegistrationProcess from "./TrademarkRegistrationProcess";
import CopyrightRegistrationProcess from "./CopyrightRegistrationProcess";
import NewsLetter from "./NewsLetter";
export class BusinessRegistration extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroCompliance />
        </div>

        <section id="about" style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>Trademark and Copyrights</h3>
              <p>
                We help you in creating and registering a unique identity for
                the goods and services you provide. Apart from filing of
                Trademark we offer you a variety of other services like
                Trademark Objection Reply and Trademark Opposition.
              </p>

             
            </header>

           
          </div>
        </section>

        <section id="why-us" style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <header class="section-header">
            <h3>A) Trademark Registration - TM Application Online</h3>
                <p>
                  Protect your brand, slogan or logo. Begin now and use the
                  trademark symbol beside your name in 3 working days.
                </p>
                {/* <h4>CTA</h4> */}
                <p>
                  CTA: A registered brand is the most valuable asset of a Company
                </p>

              <h3>How does Trademark Registration work?</h3>
              <p>
                Give your brand a unique identity by registering it’s Trademark
                online with ClipTax!
              </p>
            </header>

{/* <TrademarkRegistrationProcess/> */}
            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  {/* <i class="fa fa-diamond"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 1</h5>
                    <p class="card-text">
                      Trademark Search: We conduct a thorough search of the TM
                      directory.
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  {/* <i class="fa fa-language"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 2</h5>
                    <p class="card-text">
                      Discussion on Class: Advice on the classes you need to
                      apply under.
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  {/* <i class="fa fa-object-group"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 3</h5>
                    <p class="card-text">
                      Regular Updates: You will receive updates until
                      registration.{" "}
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section id="about" style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <div class="row about-container">
              <div class="col-lg-6 content order-lg-1 order-2">
                <h4>COPYRIGHTS REGISTERATION</h4>
                <p>
                  A Registration confers upon its owner sole rights to copy or
                  reproduce the work or grant permission to another to do so.
                </p>
                <h4>CTA</h4>
                <p>
                  Copyrights help you in building credibility in the market!
                </p>
              </div>

              <div class="col-lg-6 background order-lg-2" data-aos="zoom-in">
                <img
                  src="assets/img/about-img.svg"
                  class="img-fluid"
                  alt=""
                ></img>
              </div>
            </div>
          </div>
        </section> */}

        <section id="why-us" style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <header class="section-header">
<br/>
<br/>
            <h3>B) Copyright Registration</h3>
                <p>
                  A Registration confers upon its owner sole rights to copy or
                  reproduce the work or grant permission to another to do so.
                </p>
                {/* <h4>CTA</h4> */}
                <p>
                  CTA: Copyrights help you in building credibility in the market!
                </p>
              <h3>How does Copyrights Registration work?</h3>
              <p>
                Copyright registration in India grants its proprietor sole
                rights to distribute, replicate, reproduce the work or give
                authorization to another entity for the same.
              </p>
            </header>
{/* <CopyrightRegistrationProcess/> */}
            <div class="row row-eq-height justify-content-center">
              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="100">
                  {/* <i class="fa fa-diamond"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 1</h5>
                    <p class="card-text">
                      Data Check: Our Experts do a thorough check of the files
                      you send in.
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="200">
                  {/* <i class="fa fa-language"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 2</h5>
                    <p class="card-text">
                      Copyright Filing: We then prepare the application and file
                      the forms.
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>

              <div class="col-lg-4 mb-4">
                <div class="card" data-aos="zoom-in" data-aos-delay="300">
                  {/* <i class="fa fa-object-group"></i> */}
                  <div class="card-body">
                    <h5 class="card-title">Step 3</h5>
                    <p class="card-text">
                      Regular Updates: We'll keep you up-to-date with all
                      information passed on by the Registrar.{" "}
                    </p>
                    {/* <a href="#" class="readmore">
                      Read more{" "}
                    </a> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default BusinessRegistration;
